import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { DateServiceModule } from "@lantern/app/core/utils/date/date-service.module";
import { OverlaysModule } from "@lantern/app/core/utils/overlays";

import { IconModule } from "../../utils/icon";
import { UserActionDirectivesModule } from "../../utils/user-action-directives";
import { DatepickerInlineComponent } from "./datepicker-inline.component";
import { DatepickerComponent } from "./datepicker.component";

@NgModule({
  imports: [
    DateServiceModule,
    OverlaysModule,
    CommonModule,
    FormsModule,
    IconModule,
    UserActionDirectivesModule
  ],
  declarations: [DatepickerInlineComponent, DatepickerComponent],
  exports: [DatepickerInlineComponent, DatepickerComponent]
})
export class DatePickerModule {}
